import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Recalls from './components/Recalls';

const recalls = (props,{ t }) => (
  <Container>
    <Recalls {...props} />
  </Container>
);

recalls.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(recalls);
